module.exports = __webpack_public_path__ + "img/framework.bc667e63.png";